document.addEventListener('DOMContentLoaded', () => {
  const widget = document.querySelector('[data-epm-chat-widget]');
  if (!widget) return;

  const bubble = widget.querySelector('[data-epm-chat-bubble]');
  const windowEl = widget.querySelector('[data-epm-chat-window]');
  const closeBtn = widget.querySelector('[data-epm-chat-close]');
  const msgBox = widget.querySelector('[data-epm-chat-messages]');
  const input = widget.querySelector('[data-epm-chat-input]');
  const sendBtn = widget.querySelector('[data-epm-chat-send]');
  const leadForm = widget.querySelector('[data-epm-lead-form]');
  const submitLeadBtn = widget.querySelector('[data-epm-submit-lead]');
  const leadName = widget.querySelector('[data-epm-lead-name]');
  const leadContact = widget.querySelector('[data-epm-lead-contact]');
  const leadDates = widget.querySelector('[data-epm-lead-dates]');
  const leadRequest = widget.querySelector('[data-epm-lead-request]');

  const WORKER_URL = 'https://epm-concierge.eatpraymaui.workers.dev/';
  const AVATAR_URL = 'https://cdn.shopify.com/s/files/1/1390/7231/files/epm-concierge-avatar_png.png?v=1779754101';
  const messages = [];
  let sessionCount = 0;
  let isOpen = false;

  function addMsg(text, role) {
    if (role === 'bot') {
      const row = document.createElement('div');
      row.className = 'epm-bot-row';

      const img = document.createElement('img');
      img.className = 'epm-mini-avatar';
      img.src = AVATAR_URL;
      img.alt = '';

      const div = document.createElement('div');
      div.className = 'epm-msg bot';
      div.textContent = text;

      row.appendChild(img);
      row.appendChild(div);
      msgBox.appendChild(row);
      msgBox.scrollTop = msgBox.scrollHeight;
      return div;
    }

    const div = document.createElement('div');
    div.className = 'epm-msg user';
    div.textContent = text;
    msgBox.appendChild(div);
    msgBox.scrollTop = msgBox.scrollHeight;
    return div;
  }

  function showWelcome() {
    addMsg("Aloha! 🌺 I'm your Eat Pray Maui AI Concierge. I can help with Maui dining, activities, airport transportation, wellness, and trusted local recommendations. What can I help you with today?", 'bot');
  }

  function toggleChat(forceOpen) {
    isOpen = typeof forceOpen === 'boolean' ? forceOpen : !isOpen;
    windowEl.classList.toggle('open', isOpen);
    if (isOpen && msgBox.children.length === 0) showWelcome();
    if (isOpen) setTimeout(() => input.focus(), 100);
  }

  function getChatTarget(value) {
    if (!value) return '';

    const raw = String(value).trim();
    if (!raw) return '';

    return raw.split('#').pop().replace(/^\/+/, '').replace(/\?.*$/, '').trim();
  }

  function shouldOpenChat(trigger) {
    if (!trigger) return false;

    if (trigger.hasAttribute('data-epm-open-chat')) {
      return true;
    }

    const href = trigger.getAttribute('href') || '';
    if (!href) return false;

    return getChatTarget(href) === 'epm-chat-widget';
  }

  function openFromHashIfNeeded() {
    if (getChatTarget(window.location.href) === 'epm-chat-widget' || getChatTarget(window.location.hash) === 'epm-chat-widget') {
      toggleChat(true);
    }
  }

  async function sendMessage() {
    const text = input.value.trim();
    if (!text) return;

    if (sessionCount >= 10) {
      addMsg('You have reached the session limit. Please text us at 808-385-5829 or email jacques@eatpraymaui.com. Mahalo! 🌺', 'bot');
      return;
    }

    input.value = '';
    addMsg(text, 'user');
    messages.push({ role: 'user', content: text });
    sessionCount += 1;
    sendBtn.disabled = true;

    const typingDiv = addMsg('Thinking...', 'bot');
    typingDiv.className = 'epm-msg bot typing';

    try {
      const response = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages, sessionCount })
      });
      const data = await response.json();
      typingDiv.closest('.epm-bot-row').remove();

      if (data.fallback) {
        addMsg(data.reply, 'bot');
        leadForm.style.display = 'block';
      } else {
        addMsg(data.reply, 'bot');
        messages.push({ role: 'assistant', content: data.reply });
      }
    } catch (error) {
      typingDiv.closest('.epm-bot-row').remove();
      addMsg('Connection issue. Please text us at 808-385-5829 or email jacques@eatpraymaui.com. Mahalo!', 'bot');
      leadForm.style.display = 'block';
    } finally {
      sendBtn.disabled = false;
      input.focus();
    }
  }

  function submitLead() {
    const name = leadName.value.trim();
    const contact = leadContact.value.trim();
    const dates = leadDates.value.trim();
    const request = leadRequest.value.trim();

    if (!name || !contact) {
      alert('Please enter your name and email or phone. Mahalo!');
      return;
    }

    leadForm.innerHTML = '<p style="color:#0B4F6C;font-weight:600;text-align:center;padding:12px 0">🌺 Mahalo, ' + name + '! We will be in touch soon. Aloha!</p>';
    console.log('EPM Lead:', { name, contact, dates, request });
  }

  bubble.addEventListener('click', () => toggleChat());
  closeBtn.addEventListener('click', () => toggleChat(false));
  sendBtn.addEventListener('click', sendMessage);
  submitLeadBtn.addEventListener('click', submitLead);

  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      sendMessage();
    }
  });

  window.epmOpenChat = () => toggleChat(true);
  window.epmSendMessage = (text) => {
    const value = String(text || '').trim();
    if (!value) return;
    toggleChat(true);
    input.value = value;
    sendMessage();
  };
  openFromHashIfNeeded();

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a[href], [data-epm-open-chat]');
    if (!trigger) return;

    if (shouldOpenChat(trigger)) {
      event.preventDefault();
      toggleChat(true);
    }
  });
});
